import {
  EmployeeOfficeField,
  EmployeePositionField,
  WorkingStatusChip,
  EmployeeLinkField,
} from 'domain/shared/employee';
import { BadgeField } from 'framework/ui/field';
import PoliciesNameField from '../shared/fields/PoliciesNameField';
import PoliciesSigningField from '../shared/fields/PoliciesSigningField';
import PoliciesStateField from '../shared/fields/PoliciesStateField';
import { ComplianceDataType } from 'domain/shared/compliance';
import { DataGridLayoutGrid } from 'framework/list';

const ComplianceListForm = () => {
  return (
    <>
      <DataGridLayoutGrid
        expandable
        isExpandableItem={(data: ComplianceDataType) => data?.policies?.length > 2}
        isInitialLoaderPosition
      >
        <BadgeField
          label="Worker"
          source="employeeAlias"
          badges={[<WorkingStatusChip source="workingStatus" sx={{ ml: '5px' }} />]}
        >
          <EmployeeLinkField nameSource="employeeFullName" source="employeeAlias" label="Worker" />
        </BadgeField>

        <EmployeePositionField source="employeePositionId" label="Position" />
        <EmployeeOfficeField source="employeeOfficeId" label="Office" size={1} />
        <PoliciesNameField label="Document name" size={3} />
        <PoliciesStateField label="Stage" />
        <PoliciesSigningField label="Last signing" />
      </DataGridLayoutGrid>
    </>
  );
};

export default ComplianceListForm;
